import React from "react";
import { RiLoader4Line } from "react-icons/ri";

const Loader = () => {
  return (
    <div className="loader-container">
      <h4>Loading...</h4>
      <h1 className="loader">
        <RiLoader4Line />
      </h1>
    </div>
  );
};

export default Loader;
